import React from 'react';
import DetailKumAdmin from './DetailKumAdmin';

const Section = () => (
  <>
    <DetailKumAdmin />
  </>
);

export default Section;
